module.exports = __webpack_public_path__ + "static/media/gu.e08eac33.webp";